import { Col, Form, Modal, Row } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";
import Common_Btn from "../common-btn/Common_Btn";
import { useState, useEffect } from "react";
import Full_screen_modal from "../full_screen_modal/Full_screen_modal";
import { Success_lottie } from "../lotties/success_lottie/Success_lottie";
import "../common-css/Common_Css.css";
import "./Solar_Modal.css";
import { Contactus } from "../../../utils/apis/contact-us/ContactUs";

const Solar_Modal = ({ show, handleClose }) => {
  const [activeFlowerType, setActiveFlowerType] = useState(null);
  const [activeBudget, setActiveBudget] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    whatsapp_no: "",
    city: "",
    pincode: "",
    event_date: "",
    flower_type_id: null,
    avg_monthly_bill_id: null,
    number_of_guests: "",
    special_requirements: "",
    message: "",
    privacy_policy: false,
  });

  const [errors, setErrors] = useState({});
  const [showModal, setShowModal] = useState(false);

  // Flower Types for Events
  const flowerTypes = [
    { id: 1, name: "Wedding Event", icon: "💐" },
    { id: 2, name: "Birthday Event", icon: "🎂" },
    { id: 3, name: "Anniversary Event", icon: "💕" },
    { id: 4, name: "Corporate Event", icon: "🏢" },
    { id: 5, name: "Engagement Event", icon: "💍" },
    { id: 6, name: "Party Decor", icon: "🎉" },
    { id: 7, name: "Festival", icon: "✨" },
    { id: 8, name: "Sympathy ", icon: "🕊️" },
  ];

  // Monthly bills data
  const monthlyBills = [
    { id: 1, name: "Less than ₹5,000" },
    { id: 2, name: "₹5,000 - ₹10,000" },
    { id: 3, name: "₹10,000 - ₹20,000" },
    { id: 4, name: "₹20,000 - ₹30,000" },
    { id: 5, name: "₹30,000 - ₹50,000" },
    { id: 6, name: "More than ₹50,000" },
  ];

  useEffect(() => {
    if (showModal) {
      const timer = setTimeout(() => {
        setShowModal(false);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [showModal]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "whatsapp_no") {
      if (!/^\d*$/.test(value)) return;
      if (value.length > 10) return;
    }

    if (name === "pincode") {
      if (!/^\d*$/.test(value)) return;
      if (value.length > 6) return;
    }

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });

    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const validate = () => {
    const e = {};

    if (!formData.name.trim()) e.name = "Name is required";

    if (!formData.email.trim()) e.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      e.email = "Enter valid email address";

    if (!formData.city.trim()) e.city = "City is required";

    if (!formData.whatsapp_no) e.whatsapp_no = "WhatsApp number required";
    else if (formData.whatsapp_no.length !== 10)
      e.whatsapp_no = "Enter valid 10 digit number";

    if (!formData.pincode) e.pincode = "Pincode required";
    else if (formData.pincode.length !== 6)
      e.pincode = "Enter valid 6 digit pincode";

    if (!formData.event_date) e.event_date = "Event date is required";

    if (!formData.flower_type_id)
      e.flower_type_id = "Please select flower type";

    if (!formData.avg_monthly_bill_id)
      e.avg_monthly_bill_id = "Please select your budget range";

    if (!formData.message.trim()) e.message = "Message is required";

    if (!formData.privacy_policy)
      e.privacy_policy = "Please accept privacy policy";

    return e;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const res = await Contactus(formData);

    if (res?.success) {
      setShowModal(true);

      handleClose();

      setFormData({
        name: "",
        email: "",
        whatsapp_no: "",
        city: "",
        pincode: "",
        event_date: "",
        flower_type_id: null,
        avg_monthly_bill_id: null,
        number_of_guests: "",
        special_requirements: "",
        message: "",
        privacy_policy: false,
      });
      setActiveFlowerType(null);
      setActiveBudget(null);
      setErrors({});
    }
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        backdrop="static"
        size="lg"
      >
        <Modal.Body className="solar_modal_body">
          <div className="modal_header_holder">
            <h5 className="modal_title">
              🌸 Plan Your Dream Event with <strong>My Flower Event</strong>
            </h5>

            <button className="close_btn" onClick={handleClose}>
              <FaTimes />
            </button>
          </div>

          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label>
                    Full Name <span>*</span>
                  </Form.Label>

                  <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter Full Name*"
                  />

                  {errors.name && <p style={{ color: "red" }}>{errors.name}</p>}
                </Form.Group>
              </Col>

              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label>
                    Email Address <span>*</span>
                  </Form.Label>

                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter Email Address*"
                  />

                  {errors.email && (
                    <p style={{ color: "red" }}>{errors.email}</p>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label>
                    WhatsApp No.<span>*</span>
                  </Form.Label>

                  <Form.Control
                    type="text"
                    name="whatsapp_no"
                    value={formData.whatsapp_no}
                    onChange={handleChange}
                    placeholder="Enter 10 digit No.*"
                    maxLength={10}
                  />

                  {errors.whatsapp_no && (
                    <p style={{ color: "red" }}>{errors.whatsapp_no}</p>
                  )}
                </Form.Group>
              </Col>

              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label>
                    Enter City<span>*</span>
                  </Form.Label>

                  <Form.Control
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    placeholder="Enter City*"
                  />

                  {errors.city && <p style={{ color: "red" }}>{errors.city}</p>}
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label>
                    Pin code<span>*</span>
                  </Form.Label>

                  <Form.Control
                    type="text"
                    name="pincode"
                    value={formData.pincode}
                    onChange={handleChange}
                    placeholder="eg. 453722*"
                    maxLength={6}
                  />

                  {errors.pincode && (
                    <p style={{ color: "red" }}>{errors.pincode}</p>
                  )}
                </Form.Group>
              </Col>

              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label>
                    Event Date<span>*</span>
                  </Form.Label>

                  <Form.Control
                    type="date"
                    name="event_date"
                    value={formData.event_date}
                    onChange={handleChange}
                    min={new Date().toISOString().split("T")[0]}
                  />

                  {errors.event_date && (
                    <p style={{ color: "red" }}>{errors.event_date}</p>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label>Expected Guests (approx.)</Form.Label>

                  <Form.Control
                    type="number"
                    name="number_of_guests"
                    value={formData.number_of_guests}
                    onChange={handleChange}
                    placeholder="Number of guests"
                    min="1"
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Flower Type Selection */}
            <Form.Group className="mb-3">
              <Form.Label>
                What type of event decoration do you need?<span>*</span>
              </Form.Label>

              <div className="row g-2">
                {flowerTypes.map((flower) => (
                  <div className="col-6 col-md-4" key={flower.id}>
                    <button
                      type="button"
                      className={`budget_btn ${
                        activeFlowerType === flower.id ? "active" : ""
                      }`}
                      onClick={() => {
                        setActiveFlowerType(flower.id);
                        setFormData({
                          ...formData,
                          flower_type_id: flower.id,
                        });
                        setErrors({
                          ...errors,
                          flower_type_id: "",
                        });
                      }}
                      style={{
                        width: "100%",
                        padding: "8px 12px",
                        borderRadius: "6px",
                        border: "1px solid #ddd",
                        background:
                          activeFlowerType === flower.id
                            ? "#007bff"
                            : "#f8f9fa",
                        color: activeFlowerType === flower.id ? "#fff" : "#000",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <span style={{ marginRight: "5px" }}>{flower.icon}</span>
                      <span>{flower.name}</span>
                    </button>
                  </div>
                ))}
              </div>
              {errors.flower_type_id && (
                <p style={{ color: "red", marginTop: "5px" }}>
                  {errors.flower_type_id}
                </p>
              )}
            </Form.Group>

            {/* Budget Selection */}
            <Form.Group className="mb-3">
              <Form.Label>
                What is your budget for this event?<span>*</span>
              </Form.Label>

              <div className="row g-2">
                {monthlyBills.map((bill) => (
                  <div className="col-6 col-md-4" key={bill.id}>
                    <button
                      type="button"
                      className={`budget_btn ${
                        activeBudget === bill.id ? "active" : ""
                      }`}
                      onClick={() => {
                        setActiveBudget(bill.id);
                        setFormData({
                          ...formData,
                          avg_monthly_bill_id: bill.id,
                        });
                        setErrors({
                          ...errors,
                          avg_monthly_bill_id: "",
                        });
                      }}
                      style={{
                        width: "100%",
                        padding: "8px 12px",
                        borderRadius: "6px",
                        border: "1px solid #ddd",
                        background:
                          activeBudget === bill.id ? "#007bff" : "#f8f9fa",
                        color: activeBudget === bill.id ? "#fff" : "#000",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                      }}
                    >
                      {bill.name}
                    </button>
                  </div>
                ))}
              </div>
              {errors.avg_monthly_bill_id && (
                <p style={{ color: "red", marginTop: "5px" }}>
                  {errors.avg_monthly_bill_id}
                </p>
              )}
            </Form.Group>

            {/* Special Requirements */}
            <Form.Group className="mb-3">
              <Form.Label>Special Requirements / Theme</Form.Label>

              <Form.Control
                as="textarea"
                rows={2}
                name="special_requirements"
                value={formData.special_requirements}
                onChange={handleChange}
                placeholder="Tell us about your color preferences, theme ideas, or specific flower choices..."
              />
            </Form.Group>

            {/* Message */}
            <Form.Group className="mb-3">
              <Form.Label>
                Your message<span>*</span>
              </Form.Label>

              <Form.Control
                as="textarea"
                rows={3}
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Type your message here...*"
              />

              {errors.message && (
                <p style={{ color: "red" }}>{errors.message}</p>
              )}
            </Form.Group>

            {/* Privacy Policy */}
            <Form.Group className="mb-3">
              <Form.Check
                type="checkbox"
                name="privacy_policy"
                checked={formData.privacy_policy}
                onChange={handleChange}
                label={
                  <>
                    I have read and agree to the{" "}
                    <a
                      href="/privacy-policy"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#007bff", textDecoration: "underline" }}
                    >
                      Privacy Policy
                    </a>
                    <span style={{ color: "red" }}>*</span>
                  </>
                }
              />

              {errors.privacy_policy && (
                <p style={{ color: "red" }}>{errors.privacy_policy}</p>
              )}
            </Form.Group>

            <div className="modal_btn_holder">
              <Common_Btn text="Submit Enquiry" type="submit" />
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Full_screen_modal
        show={showModal}
        onHide={() => setShowModal(false)}
        lottie={<Success_lottie />}
      />
    </>
  );
};

export default Solar_Modal;
